export const TIME_ZONES_FETCH_STARTED = "TIME_ZONES_FETCH_STARTED";
export const TIME_ZONES_FETCH_COMPLETED = "TIME_ZONES_FETCH_COMPLETED";
export const TIME_ZONES_FETCH_FAILED = "TIME_ZONES_FETCH_FAILED";
